import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  editDudaConfiguration,
  type EditDudaConfigurationPayload,
} from 'api/admin/businesses/dudaConfiguration';

export const useEditDudaConfiguration = () => {
  return useMutation<unknown, AxiosError<{ error: string }>, EditDudaConfigurationPayload>({
    mutationFn: async ({ businessId, data }) => {
      return editDudaConfiguration({ businessId, data });
    },
    onSuccess: async () => {
      toaster('Duda configuration has been updated', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(
        error?.response?.data?.error ?? 'An error occurred while updating Duda configuration',
        {
          icon: '❌',
        },
      );
      return error;
    },
  });
};
